var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('span',[_c('v-icon',{attrs:{"size":"16"}},[_vm._v("copyright")]),_vm._v("Sulekha.com New Media Pvt. Ltd\n    ")],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }